import { cloneElement } from 'react';
import { AuthContextProps, useAuth } from 'react-oidc-context';
import { useLocation, Navigate } from 'react-router-dom';
import { UserRole } from '../data/auth-data';
import AppRoutes from 'src/features/router/data/app-routes';

export const getUserRoles = (auth: AuthContextProps) => {
    let userProfiles: UserRole[] = [];
    if (!Array.isArray(auth.user!.profile.role)) {
        userProfiles.push(auth.user!.profile.role as UserRole);
    } else {
        userProfiles = Object.assign([], auth.user!.profile.role);
    }

    return userProfiles;
};

export const hasAuthorizedRoleForRequestedPath = (userProfiles: UserRole[], role: UserRole) => {
    if (userProfiles.every((x: UserRole) => Number.isNaN(+UserRole[x]) || +UserRole[x] < role)) {
        return false;
    }
    return true;
};

export const hasAtLeastOneFlexReturnRole = (userProfiles: UserRole[]) => {
    if (!userProfiles.some((role: UserRole) => UserRole[role])) {
        return false;
    }
    return true;
};

const RequireAuth = ({
    children,
    role,
    redirect,
}: {
    children: JSX.Element;
    role: UserRole;
    redirect: boolean;
}) => {
    const auth = useAuth();
    const location = useLocation();
    let userProfiles: UserRole[] = [];

    const handleRedirection = (landingDestination: string) => {
        if (!redirect) {
            return <></>;
        }

        return <Navigate to={landingDestination} state={{ from: location }} replace />;
    };

    const setUserRoles = () => {
        userProfiles = getUserRoles(auth);
    };

    if (auth.isLoading) {
        return handleRedirection(location.pathname);
    }

    if (!auth.user || !auth.isAuthenticated) {
        return handleRedirection(AppRoutes.loginPath);
    }

    if (!auth.user.profile.role) {
        return handleRedirection(AppRoutes.unauthorizedPath);
    }

    setUserRoles();

    if (!hasAtLeastOneFlexReturnRole(userProfiles)) {
        return handleRedirection(AppRoutes.unauthorizedPath);
    }

    if (!hasAuthorizedRoleForRequestedPath(userProfiles, role)) {
        return handleRedirection(AppRoutes.unauthorizedPath);
    }

    const childrenClone = cloneElement(children, {
        ...children.props,
        token: auth.user?.access_token,
    });

    return <>{childrenClone}</>;
};

export default RequireAuth;
